export const data = { content:"{\"openapi\":\"3.1.0\",\"info\":{\"title\":\"CertiDrive API\",\"version\":\"1.0.0\",\"description\":\"API available for customers. All endpoints require an API key.\"},\"servers\":[{\"url\":\"https://api.certidrive.se\",\"description\":\"Production\"}],\"security\":[{\"bearerApiKey\":[]},{\"xApiKey\":[]}],\"tags\":[{\"name\":\"Customers\"},{\"name\":\"Registrations\"},{\"name\":\"Stock\"}],\"paths\":{\"/v1/customers\":{\"get\":{\"tags\":[\"Customers\"],\"summary\":\"List customers\",\"parameters\":[{\"$ref\":\"#/components/parameters/Limit\"},{\"$ref\":\"#/components/parameters/Offset\"},{\"name\":\"group_id\",\"in\":\"query\",\"schema\":{\"type\":\"string\",\"format\":\"uuid\"}},{\"name\":\"organization_number\",\"in\":\"query\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"required\":[\"items\"],\"properties\":{\"items\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/components/schemas/Customer\"}}}}}}}}},\"post\":{\"tags\":[\"Customers\"],\"summary\":\"Create customer\",\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CustomerCreateRequest\"}}}},\"responses\":{\"201\":{\"description\":\"Created\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/Customer\"}}}}}}},\"/v1/customers/{id}\":{\"get\":{\"tags\":[\"Customers\"],\"summary\":\"Get customer\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/Customer\"}}}}}},\"patch\":{\"tags\":[\"Customers\"],\"summary\":\"Update customer\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CustomerUpdateRequest\"}}}},\"responses\":{\"200\":{\"description\":\"Updated\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/Customer\"}}}}}},\"delete\":{\"tags\":[\"Customers\"],\"summary\":\"Delete customer\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"responses\":{\"204\":{\"description\":\"Deleted\"}}}},\"/v1/registrations\":{\"get\":{\"tags\":[\"Registrations\"],\"summary\":\"List registrations\",\"parameters\":[{\"$ref\":\"#/components/parameters/Limit\"},{\"$ref\":\"#/components/parameters/Offset\"},{\"name\":\"group_id\",\"in\":\"query\",\"schema\":{\"type\":\"string\",\"format\":\"uuid\"}},{\"name\":\"vin\",\"in\":\"query\",\"schema\":{\"type\":\"string\"}},{\"name\":\"status\",\"in\":\"query\",\"schema\":{\"type\":\"string\"}},{\"name\":\"environment\",\"in\":\"query\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"required\":[\"items\"],\"properties\":{\"items\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/components/schemas/Registration\"}}}}}}}}},\"post\":{\"tags\":[\"Registrations\"],\"summary\":\"Create registration\",\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/RegistrationCreateRequest\"}}}},\"responses\":{\"201\":{\"description\":\"Created\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/Registration\"}}}}}}},\"/v1/registrations/{id}\":{\"get\":{\"tags\":[\"Registrations\"],\"summary\":\"Get registration\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/Registration\"}}}}}},\"patch\":{\"tags\":[\"Registrations\"],\"summary\":\"Update registration\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/RegistrationUpdateRequest\"}}}},\"responses\":{\"200\":{\"description\":\"Updated\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/Registration\"}}}}}},\"delete\":{\"tags\":[\"Registrations\"],\"summary\":\"Delete registration\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"responses\":{\"204\":{\"description\":\"Deleted\"}}}},\"/v1/stock\":{\"get\":{\"tags\":[\"Stock\"],\"summary\":\"List stock items\",\"parameters\":[{\"$ref\":\"#/components/parameters/Limit\"},{\"$ref\":\"#/components/parameters/Offset\"},{\"name\":\"group_id\",\"in\":\"query\",\"schema\":{\"type\":\"string\",\"format\":\"uuid\"}},{\"name\":\"vin\",\"in\":\"query\",\"schema\":{\"type\":\"string\"}},{\"name\":\"make\",\"in\":\"query\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"required\":[\"items\"],\"properties\":{\"items\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/components/schemas/StockItem\"}}}}}}}}},\"post\":{\"tags\":[\"Stock\"],\"summary\":\"Create stock item\",\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/StockItemCreateRequest\"}}}},\"responses\":{\"201\":{\"description\":\"Created\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/StockItem\"}}}}}}},\"/v1/stock/{id}\":{\"get\":{\"tags\":[\"Stock\"],\"summary\":\"Get stock item\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/StockItem\"}}}}}},\"patch\":{\"tags\":[\"Stock\"],\"summary\":\"Update stock item\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/StockItemUpdateRequest\"}}}},\"responses\":{\"200\":{\"description\":\"Updated\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/StockItem\"}}}}}},\"delete\":{\"tags\":[\"Stock\"],\"summary\":\"Delete stock item\",\"parameters\":[{\"$ref\":\"#/components/parameters/BigintId\"}],\"responses\":{\"204\":{\"description\":\"Deleted\"}}}}},\"components\":{\"securitySchemes\":{\"bearerApiKey\":{\"type\":\"http\",\"scheme\":\"bearer\",\"bearerFormat\":\"APIKEY\",\"description\":\"Authorization: Bearer <API_KEY>\"},\"xApiKey\":{\"type\":\"apiKey\",\"in\":\"header\",\"name\":\"x-api-key\",\"description\":\"x-api-key: <API_KEY>\"}},\"parameters\":{\"Limit\":{\"name\":\"limit\",\"in\":\"query\",\"required\":false,\"schema\":{\"type\":\"integer\",\"minimum\":1,\"maximum\":200,\"default\":20}},\"Offset\":{\"name\":\"offset\",\"in\":\"query\",\"required\":false,\"schema\":{\"type\":\"integer\",\"minimum\":0,\"default\":0}},\"BigintId\":{\"name\":\"id\",\"in\":\"path\",\"required\":true,\"schema\":{\"type\":\"integer\",\"minimum\":1},\"description\":\"bigint identity id\"}},\"schemas\":{\"JsonObject\":{\"type\":\"object\",\"additionalProperties\":true},\"Customer\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"created_at\"],\"properties\":{\"id\":{\"type\":\"integer\",\"readOnly\":true},\"created_at\":{\"type\":\"string\",\"format\":\"date-time\",\"readOnly\":true},\"name\":{\"type\":[\"string\",\"null\"]},\"organization_number\":{\"type\":[\"string\",\"null\"]},\"group_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"}}},\"CustomerCreateRequest\":{\"type\":\"object\",\"additionalProperties\":false,\"properties\":{\"name\":{\"type\":[\"string\",\"null\"]},\"organization_number\":{\"type\":[\"string\",\"null\"]},\"group_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"}}},\"CustomerUpdateRequest\":{\"$ref\":\"#/components/schemas/CustomerCreateRequest\"},\"Registration\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"created_at\",\"poll_enabled\"],\"properties\":{\"id\":{\"type\":\"integer\",\"readOnly\":true},\"created_at\":{\"type\":\"string\",\"format\":\"date-time\",\"readOnly\":true},\"data\":{\"$ref\":\"#/components/schemas/JsonObject\"},\"status\":{\"type\":[\"string\",\"null\"]},\"group_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"vin\":{\"type\":[\"string\",\"null\"]},\"owner\":{\"type\":[\"string\",\"null\"]},\"ts_caseid\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"ts_messageid\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"ts_application_status\":{\"type\":[\"string\",\"null\"]},\"updated_at\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\",\"readOnly\":true},\"reg_number\":{\"type\":[\"string\",\"null\"]},\"ts_case_reference_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"poll_enabled\":{\"type\":\"boolean\"},\"next_poll_at\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"last_polled_at\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"status_message\":{\"type\":[\"string\",\"null\"]},\"ts_status_updated_at\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"environment\":{\"type\":[\"string\",\"null\"]}}},\"RegistrationCreateRequest\":{\"type\":\"object\",\"additionalProperties\":false,\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/JsonObject\"},\"status\":{\"type\":[\"string\",\"null\"]},\"group_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"vin\":{\"type\":[\"string\",\"null\"]},\"owner\":{\"type\":[\"string\",\"null\"]},\"poll_enabled\":{\"type\":[\"boolean\",\"null\"]},\"environment\":{\"type\":[\"string\",\"null\"]}}},\"RegistrationUpdateRequest\":{\"$ref\":\"#/components/schemas/RegistrationCreateRequest\"},\"StockItem\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"created_at\"],\"properties\":{\"id\":{\"type\":\"integer\",\"readOnly\":true},\"created_at\":{\"type\":\"string\",\"format\":\"date-time\",\"readOnly\":true},\"vin\":{\"type\":[\"string\",\"null\"]},\"make\":{\"type\":[\"string\",\"null\"]},\"type_approval\":{\"type\":[\"string\",\"null\"]},\"group_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"pt\":{\"type\":[\"integer\",\"null\"]},\"model\":{\"type\":[\"string\",\"null\"]}}},\"StockItemCreateRequest\":{\"type\":\"object\",\"additionalProperties\":false,\"properties\":{\"vin\":{\"type\":[\"string\",\"null\"]},\"make\":{\"type\":[\"string\",\"null\"]},\"type_approval\":{\"type\":[\"string\",\"null\"]},\"group_id\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"pt\":{\"type\":[\"integer\",\"null\"]},\"model\":{\"type\":[\"string\",\"null\"]}}},\"StockItemUpdateRequest\":{\"$ref\":\"#/components/schemas/StockItemCreateRequest\"}}},\"x-ext-urls\":{}}",
  parsed:{ openapi:"3.1.0",
    info:{ title:"CertiDrive API",
      version:"1.0.0",
      description:"API available for customers. All endpoints require an API key." },
    servers:[ { url:"https://api.certidrive.se",
        description:"Production" } ],
    security:[ { bearerApiKey:[  ] },
      { xApiKey:[  ] } ],
    tags:[ { name:"Customers" },
      { name:"Registrations" },
      { name:"Stock" } ],
    paths:{ "/v1/customers":{ get:{ tags:[ "Customers" ],
          summary:"List customers",
          parameters:[ { $ref:"#/components/parameters/Limit" },
            { $ref:"#/components/parameters/Offset" },
            { name:"group_id",
              "in":"query",
              schema:{ type:"string",
                format:"uuid" } },
            { name:"organization_number",
              "in":"query",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ type:"object",
                    required:[ "items" ],
                    properties:{ items:{ type:"array",
                        items:{ $ref:"#/components/schemas/Customer" } } } } } } } } },
        post:{ tags:[ "Customers" ],
          summary:"Create customer",
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/CustomerCreateRequest" } } } },
          responses:{ 201:{ description:"Created",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/Customer" } } } } } } },
      "/v1/customers/{id}":{ get:{ tags:[ "Customers" ],
          summary:"Get customer",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/Customer" } } } } } },
        patch:{ tags:[ "Customers" ],
          summary:"Update customer",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/CustomerUpdateRequest" } } } },
          responses:{ 200:{ description:"Updated",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/Customer" } } } } } },
        "delete":{ tags:[ "Customers" ],
          summary:"Delete customer",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          responses:{ 204:{ description:"Deleted" } } } },
      "/v1/registrations":{ get:{ tags:[ "Registrations" ],
          summary:"List registrations",
          parameters:[ { $ref:"#/components/parameters/Limit" },
            { $ref:"#/components/parameters/Offset" },
            { name:"group_id",
              "in":"query",
              schema:{ type:"string",
                format:"uuid" } },
            { name:"vin",
              "in":"query",
              schema:{ type:"string" } },
            { name:"status",
              "in":"query",
              schema:{ type:"string" } },
            { name:"environment",
              "in":"query",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ type:"object",
                    required:[ "items" ],
                    properties:{ items:{ type:"array",
                        items:{ $ref:"#/components/schemas/Registration" } } } } } } } } },
        post:{ tags:[ "Registrations" ],
          summary:"Create registration",
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/RegistrationCreateRequest" } } } },
          responses:{ 201:{ description:"Created",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/Registration" } } } } } } },
      "/v1/registrations/{id}":{ get:{ tags:[ "Registrations" ],
          summary:"Get registration",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/Registration" } } } } } },
        patch:{ tags:[ "Registrations" ],
          summary:"Update registration",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/RegistrationUpdateRequest" } } } },
          responses:{ 200:{ description:"Updated",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/Registration" } } } } } },
        "delete":{ tags:[ "Registrations" ],
          summary:"Delete registration",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          responses:{ 204:{ description:"Deleted" } } } },
      "/v1/stock":{ get:{ tags:[ "Stock" ],
          summary:"List stock items",
          parameters:[ { $ref:"#/components/parameters/Limit" },
            { $ref:"#/components/parameters/Offset" },
            { name:"group_id",
              "in":"query",
              schema:{ type:"string",
                format:"uuid" } },
            { name:"vin",
              "in":"query",
              schema:{ type:"string" } },
            { name:"make",
              "in":"query",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ type:"object",
                    required:[ "items" ],
                    properties:{ items:{ type:"array",
                        items:{ $ref:"#/components/schemas/StockItem" } } } } } } } } },
        post:{ tags:[ "Stock" ],
          summary:"Create stock item",
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/StockItemCreateRequest" } } } },
          responses:{ 201:{ description:"Created",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/StockItem" } } } } } } },
      "/v1/stock/{id}":{ get:{ tags:[ "Stock" ],
          summary:"Get stock item",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/StockItem" } } } } } },
        patch:{ tags:[ "Stock" ],
          summary:"Update stock item",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ $ref:"#/components/schemas/StockItemUpdateRequest" } } } },
          responses:{ 200:{ description:"Updated",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/StockItem" } } } } } },
        "delete":{ tags:[ "Stock" ],
          summary:"Delete stock item",
          parameters:[ { $ref:"#/components/parameters/BigintId" } ],
          responses:{ 204:{ description:"Deleted" } } } } },
    components:{ securitySchemes:{ bearerApiKey:{ type:"http",
          scheme:"bearer",
          bearerFormat:"APIKEY",
          description:"Authorization: Bearer <API_KEY>" },
        xApiKey:{ type:"apiKey",
          "in":"header",
          name:"x-api-key",
          description:"x-api-key: <API_KEY>" } },
      parameters:{ Limit:{ name:"limit",
          "in":"query",
          required:false,
          schema:{ type:"integer",
            minimum:1,
            maximum:200,
            "default":20 } },
        Offset:{ name:"offset",
          "in":"query",
          required:false,
          schema:{ type:"integer",
            minimum:0,
            "default":0 } },
        BigintId:{ name:"id",
          "in":"path",
          required:true,
          schema:{ type:"integer",
            minimum:1 },
          description:"bigint identity id" } },
      schemas:{ JsonObject:{ type:"object",
          additionalProperties:true },
        Customer:{ type:"object",
          additionalProperties:false,
          required:[ "id",
            "created_at" ],
          properties:{ id:{ type:"integer",
              readOnly:true },
            created_at:{ type:"string",
              format:"date-time",
              readOnly:true },
            name:{ type:[ "string",
                "null" ] },
            organization_number:{ type:[ "string",
                "null" ] },
            group_id:{ type:[ "string",
                "null" ],
              format:"uuid" } } },
        CustomerCreateRequest:{ type:"object",
          additionalProperties:false,
          properties:{ name:{ type:[ "string",
                "null" ] },
            organization_number:{ type:[ "string",
                "null" ] },
            group_id:{ type:[ "string",
                "null" ],
              format:"uuid" } } },
        CustomerUpdateRequest:{ $ref:"#/components/schemas/CustomerCreateRequest" },
        Registration:{ type:"object",
          additionalProperties:false,
          required:[ "id",
            "created_at",
            "poll_enabled" ],
          properties:{ id:{ type:"integer",
              readOnly:true },
            created_at:{ type:"string",
              format:"date-time",
              readOnly:true },
            data:{ $ref:"#/components/schemas/JsonObject" },
            status:{ type:[ "string",
                "null" ] },
            group_id:{ type:[ "string",
                "null" ],
              format:"uuid" },
            vin:{ type:[ "string",
                "null" ] },
            owner:{ type:[ "string",
                "null" ] },
            ts_caseid:{ type:[ "string",
                "null" ],
              format:"uuid" },
            ts_messageid:{ type:[ "string",
                "null" ],
              format:"uuid" },
            ts_application_status:{ type:[ "string",
                "null" ] },
            updated_at:{ type:[ "string",
                "null" ],
              format:"date-time",
              readOnly:true },
            reg_number:{ type:[ "string",
                "null" ] },
            ts_case_reference_id:{ type:[ "string",
                "null" ],
              format:"uuid" },
            poll_enabled:{ type:"boolean" },
            next_poll_at:{ type:[ "string",
                "null" ],
              format:"date-time" },
            last_polled_at:{ type:[ "string",
                "null" ],
              format:"date-time" },
            status_message:{ type:[ "string",
                "null" ] },
            ts_status_updated_at:{ type:[ "string",
                "null" ],
              format:"date-time" },
            environment:{ type:[ "string",
                "null" ] } } },
        RegistrationCreateRequest:{ type:"object",
          additionalProperties:false,
          properties:{ data:{ $ref:"#/components/schemas/JsonObject" },
            status:{ type:[ "string",
                "null" ] },
            group_id:{ type:[ "string",
                "null" ],
              format:"uuid" },
            vin:{ type:[ "string",
                "null" ] },
            owner:{ type:[ "string",
                "null" ] },
            poll_enabled:{ type:[ "boolean",
                "null" ] },
            environment:{ type:[ "string",
                "null" ] } } },
        RegistrationUpdateRequest:{ $ref:"#/components/schemas/RegistrationCreateRequest" },
        StockItem:{ type:"object",
          additionalProperties:false,
          required:[ "id",
            "created_at" ],
          properties:{ id:{ type:"integer",
              readOnly:true },
            created_at:{ type:"string",
              format:"date-time",
              readOnly:true },
            vin:{ type:[ "string",
                "null" ] },
            make:{ type:[ "string",
                "null" ] },
            type_approval:{ type:[ "string",
                "null" ] },
            group_id:{ type:[ "string",
                "null" ],
              format:"uuid" },
            pt:{ type:[ "integer",
                "null" ] },
            model:{ type:[ "string",
                "null" ] } } },
        StockItemCreateRequest:{ type:"object",
          additionalProperties:false,
          properties:{ vin:{ type:[ "string",
                "null" ] },
            make:{ type:[ "string",
                "null" ] },
            type_approval:{ type:[ "string",
                "null" ] },
            group_id:{ type:[ "string",
                "null" ],
              format:"uuid" },
            pt:{ type:[ "integer",
                "null" ] },
            model:{ type:[ "string",
                "null" ] } } },
        StockItemUpdateRequest:{ $ref:"#/components/schemas/StockItemCreateRequest" } } },
    "x-ext-urls":{} } }